// extracted by mini-css-extract-plugin
export default {"btns_icon":"ButtonsOptions_btns_icon__WnFnt","btns":"ButtonsOptions_btns__0R-jZ"};